import { addCompareItem, removeCompareItem, getCompareItems } from './comparador-storage.js';

export default function initCompareTriggers() {
    const buttons = document.querySelectorAll('.js-compare-btn');
    const checkboxes = document.querySelectorAll('.js-compare-checkbox');

    // ==========================================
    // 1. SINCRONIZAÇÃO DA TELA
    // ==========================================
    function syncUI() {
        const items = getCompareItems();
        const inStoreIds = items.map(item => String(item.id));
        const isFull = items.length >= 3; // Verifica se atingiu o limite

        buttons.forEach(btn => {
            const id = btn.getAttribute('data-compare-id');
            const isActive = inStoreIds.includes(id);

            if (isActive) {
                // Se o produto JÁ ESTÁ no comparador
                btn.classList.add('c-compare-btn--is-active');
                btn.classList.remove('c-compare-btn--is-disabled');
            } else {
                // Se o produto NÃO ESTÁ no comparador
                btn.classList.remove('c-compare-btn--is-active');

                if (isFull) {
                    // Se não está no comparador mas a lista está cheia, bloqueia
                    btn.classList.add('c-compare-btn--is-disabled');
                } else {
                    // Se tem espaço na lista, libera
                    btn.classList.remove('c-compare-btn--is-disabled');
                }
            }
        });

        // Sincroniza os Checkboxes (opcional: você pode desativar o input também)
        checkboxes.forEach(cb => {
            const id = cb.getAttribute('data-compare-id');
            const isActive = inStoreIds.includes(id);

            cb.checked = isActive;

            // Desativa o checkbox se estiver cheio e ele não for um dos selecionados
            if (isFull && !isActive) {
                cb.disabled = true;
                cb.parentElement.style.opacity = '0.5';
            } else {
                cb.disabled = false;
                cb.parentElement.style.opacity = '1';
            }
        });
    }

    // ==========================================
    // 2. EVENTOS DE CLIQUE
    // ==========================================

    // Evento para os botões nos cards
    buttons.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const id = btn.getAttribute('data-compare-id');

            // Verifica se o botão já está no estado ativo
            if (btn.classList.contains('c-compare-btn--is-active')) {
                // Se sim, o usuário quer REMOVER
                removeCompareItem(id);
            } else {
                // Se não, o usuário quer ADICIONAR
                const item = {
                    id: id,
                    title: btn.getAttribute('data-compare-title'),
                    image: btn.getAttribute('data-compare-image'),
                    link: btn.getAttribute('data-compare-link')
                };

                const wasAdded = addCompareItem(item);
                if (!wasAdded) {
                    alert('Você pode comparar no máximo 3 produtos por vez.');
                }
            }
        });
    });

    // Evento para os checkboxes (mantido como estava)
    checkboxes.forEach(cb => {
        cb.addEventListener('change', () => {
            const id = cb.getAttribute('data-compare-id');

            if (cb.checked) {
                const item = {
                    id: id,
                    title: cb.getAttribute('data-compare-title'),
                    image: cb.getAttribute('data-compare-image'),
                    link: cb.getAttribute('data-compare-link')
                };
                const wasAdded = addCompareItem(item);

                if (!wasAdded) {
                    cb.checked = false;
                    alert('Você pode comparar no máximo 3 produtos por vez.');
                }
            } else {
                removeCompareItem(id);
            }
        });
    });

    // ==========================================
    // 3. INICIALIZAÇÃO
    // ==========================================

    syncUI(); // Roda ao carregar a página
    document.addEventListener('pdrCompareUpdated', syncUI); // Roda sempre que o comparador mudar
}